import { useState, useEffect } from "react";
import MainCarousel from "../../components/Landing/MainCarousel";
import PatientCard from "../../components/PaitientCard/PatientCard";
import styles from "./PatientInfo.module.scss";
import styled from "styled-components";


const DiabeticBlog = ({ type,setSearchText }) => {
  

  return (
    <div className="row">
          {/* <!-- Post Item #1  --> */}
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="post-item">
              <div className="post__img">
                <a href="blog-single-post.html">
                  <img src="../../assets/images/blog/1.jpeg" alt="post image" loading="lazy"  width="98%" height="500px"/>
                </a>
              </div>{/* <!-- /.post__img  --> */}
              <div className="post__body">
                <div className="post__meta-cat">
                  <a href="#">Diabetic Diet</a>
                </div>{/* <!-- /.blog-meta-cat  --> */}
                <div className="post__meta d-flex">
                  <span className="post__meta-date">Jan 30, 2022</span>
                  <a className="post__meta-author" href="#">A Das</a>
                </div>
                <h4 className="post__title">Diabetes is a difficult disease to live with</h4>

                <p className="post__desc">Diabetes is a difficult disease to live with in more ways than one. Alongside the constant medications and blood glucose monitoring, lifestyle modification is the best way to live a long and otherwise healthy life. As a result, it is essential to modify your diet and get sufficient exercise every day. To make things easy for you, here is what a typical diabetic diet looks like:
                </p>

                <h4 className="post__title" style={{marginBottom: "10px !important"}}>Early Morning:</h4>

                  <span className="post__desc page-margin">
                  1.	Black Tea / Black coffee – 1 cup without sugar <br/>
                  2.	Biscuit – 1 pc (thin/cream cracker/digestive) OR Puffed Rice – 3 tbsp.<br/>
                  3.	2 Almonds<br/><br/>
                  </span>

                  <h4 className="post__title"> Breakfast:</h4>

                  <span className="post__desc">
                  1.	Any low-sugar cereal items – 30g (1/2 cup cornflakes / ½ cup Puffed Rice / ¼ cup chiwda (raw) / ¼ cup rolled oats / 1 or 2 medium sized rotis / 2 pcs brown bread / 1 cup noodles / dalia with vegetables / poha)<br/>
                  2.	½ cup curd / 1 egg white / paneer bhurji / scrambled eggs with vegetables<br/>
                  3.	Mixed vegetable curry – 1 bowl (cooked)<br/><br/>

                  </span>


                  <h4 className="post__title">  Mid-Morning snacks (2 Hours After breakfast) </h4>
                  <span className="post__desc">
                    1.	1 whole fruit / Mixed fruit – 100 grams (papaya / watermelon / orange / musumbi / guava / kalojam / 1 small banana per week / pear)
                    Lunch & Dinner<br/>
                    2.	Rice – 40 gm / 1 bowl cooked / 2 pcs medium (50 gms) atta chapati<br/>
                    3.	Dal – ½ bowl (medium) cooked / 1 pc papad / ½ bowl rajma<br/>
                    4.	Fish – 70 gm / Channa / Curd out of 250 mL double toned milk<br/>
                    5.	Mixed vegetable – 1 or 2 bowls cooked in as less oil as possible<br/>
                    6.	Mixed salad – 1 bowl (100 gm) cucumber, bellpeppers, onion, lemon<br/><br/>
                    </span>
                    <h4 className="post__title">  Afternoon Snacks</h4>
                    <span className="post__desc">
                    1.	1 cup tea<br/>
                    2.	1 biscuit (thin / cream crackers/ digestive)<br/><br/>
                    </span>
                    <h4 className="post__title"> Evening Snacks</h4>
                    <span className="post__desc">
                    1.	Bread toast – 1medium slice brown bread / 25 gm puffed rice + cucumber / poha / 1 bowl fried chiwda<br/>
                    2.	10gm Peanut / Mung / Channa<br/><br/>
                    </span>
                    <h4 className="post__title">  Items to Avoid </h4>
                    <span className="post__desc">
                    -	All kinds of Processed or preserved foods, canned foods, soft drinks, fruit juices<br/>
                    -	Instant products like maida, suji, biscuits, white bread, chanachur, bhujia<br/>
                    -	Simple sugars like Sweets, sugar, glucose, artificial sweetners<br/>
                    -	High fructose corn syrup<br/>
                    -	Tubers like potato, tapioca (saboo)<br/>
                    -	Ghee, Butter<br/>
                    -	Sweet items like cakes, pastries, chocolate, ice cream<br/>
                    -	Red meat, egg yolk, prawn<br/>
                    -	Table salt<br/>
                    -	Fried food, junk food<br/>
                    -	Fruits to be avoided: Mango, Banana (1 per week only), Litchi, Chiku<br/><br/>
                    </span>
                    <h4 className="post__title">  Must Eat: </h4>
                    <span className="post__desc">
                    -	All kinds of green vegetables<br/>
                    -	Whole cereals, whole pulses, pulses with skin, legumes<br/>
                    -	Fruits, especially citrus fruits & berries<br/>
                    -	Skimmed milk, Skimmed milk products like curd & paneer<br/>
                    -	Fish, Chicken & Egg white– boiled, roasted, grilled, or baked<br/>
                    -	Nuts like Almonds or Walnuts<br/><br/>
                    </span>
                    <h4 className="post__title">  Water intake: 2.5L per day </h4>
                    <span className="post__desc">
                    Exercise: 30 minutes of Brisk walking per day <br/><br/></span>
                    <h4 className="post__title">  Notes:</h4>
                    <span className="post__desc">
                    1.	If fasting sugar is above 200 mg/dL, then stop fruits<br/>
                    2.	Small frequent meals are to be taken at regular intervals, preferably 2 hours<br/>
                    3.	No water intake immediately after meals<br/>
                    4.	Give a gap of 2 hours between dinner and bedtime<br/><br/>
                    </span>
                 
              </div>{/* <!-- /.post__body  --> */}
            </div>{/* <!-- /.post-item  --> */}
          </div>{/* <!-- /.col-lg-4  --> */}
          </div>
  );
};

const Card = styled.div`
  background-color: white;
  border: 2px solid #d5d5d5;
  padding: 0.5rem;
  border-radius: 10px;
  flex-grow: 1;
  flex-basis: 46%;
  h6 {
    text-align: center;
    font-size: 1rem;
    margin-block: 3%;
  }
  ul {
    padding-left: 10%;
  }
  a {
    padding-left: 10%;
    color: #651fff !important;
  }
`;

export default DiabeticBlog;
